import { Requisition } from '@customTypes/requisition';
import { startCase, kebabCase } from 'lodash';

export const FVTSection = ({ fvt }: { fvt: Requisition['fvt'] }) => {
  if (!fvt || !fvt.variants?.length) return null;

  return (
    <>
      {fvt.source_requisition && (
        <p className='mb-0'>
          <span className='fw-medium'>Relative Order ID: </span>
          {fvt.source_requisition}
        </p>
      )}
      <p className='mb-0 relationship-to-tested-relative'>
        <span className='fw-medium'>Relationship to Tested Relative: </span>
        {startCase(kebabCase(fvt.source_relationship))}
      </p>
      <p className='mb-0 variants'>
        <span className='fw-medium label'>Requested Variants to Test </span>
        {fvt.variants.map(variant => (
          <span key={variant.enum} className='d-block variant'>
            {variant.title}
          </span>
        ))}
      </p>
    </>
  );
};
